<template>
  <div class>
    <Toast />

    <div class="card">
      <h5>
        <b>Tambah Mutasi Harga</b>
      </h5>
      <div class="p-grid p-mb-6">
        <div class="p-col-12" style="overflow-x: auto">
          <table class="table table-responsive table-bordered">
            <thead class="thead-light">
              <tr>
                <th>No</th>
                <th>Kode Barang</th>
                <th>Nama Barang</th>
                <th>Harga Modal (Rp)</th>
                <th v-for="(item, r) in outlets" :key="r">
                  {{ item.alias }} (Rp)
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(an_item, k) in items_temp" :key="k">
                <td>
                  {{ k + 1 }}
                </td>
                <td>
                  <div class="item">
                    <AutoComplete
                      placeholder="Kode Barang"
                      id="code"
                      :dropdown="true"
                      :multiple="false"
                      v-model="an_item.dropdownItem"
                      :suggestions="dropdownItems"
                      @complete="getDetailPurchase(k)"
                      @input="chooseDropdownChanges(k, an_item)"
                      @keyup.enter="nextFocusItemCode"
                      field="code"
                      autofocus
                    />
                  </div>
                  <small class="p-error" v-if="isError.items[k].kode_barang">{{
                    error_msg.items[k].kode_barang
                  }}</small>
                </td>
                <td>
                  <div class="item">
                    <InputText
                      :readonly="true"
                      class="form-control"
                      id="name"
                      type="text"
                      v-model="an_item.item_name.name"
                      placeholder="Nama Barang"
                    />
                  </div>
                </td>
                <td>
                  <div class="priceCol">
                    <InputText
                      :readonly="true"
                      class="form-control"
                      id="cap-price"
                      v-model="an_item.cap_priceRP"
                      placeholder="0"
                    />
                  </div>
                </td>
                <td v-for="(outlet, r) in an_item.warehouse_outbounds" :key="r">
                  <tr>
                    <div class="items">
                      <InputNumber
                        mode="decimal"
                        locale="id-ID"
                        id="outlet-price"
                        v-model="outlet.price"
                        min="0"
                        placeholder="0"
                        @keyup.enter="nextFocusItemCode"
                      />
                    </div>
                  </tr>
                </td>
                <td scope="row" class="trashIconContainer">
                  <Button
                    type="button"
                    icon="pi pi-trash"
                    class="p-button-danger"
                    @click="deleteRow(k, an_item)"
                  ></Button>
                </td>
              </tr>
            </tbody>
          </table>
          <br /><br /><br /><br /><br /><br /><br />
        </div>
      </div>

      <div align="right">
        <Button
          icon="pi pi-plus"
          label="Tambah"
          class="p-mr-2"
          @click="addNewRow"
        />
      </div>
      <br />

      <div class="p-grid p-justify-center">
        <div class="p-col-3" v-if="items_temp.length != 0">
          <!-- <Button
            type="button"
            style="width: 100%"
            label="Simpan"
            @click="submit"
          /> -->
          <Button
            type="button"
            label="Simpan"
            style="width: 100%"
            @click="submit()"
          >
            <span v-if="loading_simpan">
              <i class="pi pi-spin pi-spinner" style="fontsize: 12px"></i>
            </span>
          </Button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      autoFiltered: [],
      dropdownItems: null,
      outlets: [],
      items_checked: false,
      loading_simpan: false,
      isError: {
        items: [
          {
            kode_barang: false,
            price: false
          }
        ]
      },
      error_msg: {
        items: [
          {
            kode_barang: '',
            price: ''
          }
        ]
      },
      inputData: {
        type: '',
        items: []
      },
      items_temp: []
    }
  },
  mounted() {
    this.getOutlets()
  },
  methods: {
    nextFocusQty(event) {
      event.target.parentElement.parentElement.nextElementSibling.children[0].children[0].nextElementSibling.focus()
    },
    // nextFocusQtyElse(event, index) {
    //   if (
    //     event.target.parentElement.parentElement.parentElement
    //       .nextElementSibling.children[0].children[0].id == "total-qty"
    //   ) {
    //     event.target.parentElement.parentElement.parentElement.nextElementSibling.nextElementSibling.children[0].children[0].nextElementSibling.focus();
    //     if (this.selectedType.code == "GIFT_MUTATION") {
    //       this.addNewRow();
    //       setTimeout(() => {
    //         event.target.parentElement.parentElement.parentElement.parentElement.parentElement.children[
    //           index + 1
    //         ].children[0].nextElementSibling.children[0].children[0].children[0].focus();
    //       }, 0);
    //     }
    //   } else {
    //     event.target.parentElement.parentElement.parentElement.nextElementSibling.children[0].children[0].children[0].focus();
    //   }
    // },
    nextFocusItemCode(event) {
      event.target.parentElement.parentElement.parentElement.nextElementSibling.children[0].children[0].children[0].focus()
    },
    nextFocusPrice(event) {
      event.target.parentElement.parentElement.nextElementSibling.children[0].focus()
    },
    nextFocusPriceOutlet(event) {
      if (
        event.target.parentElement.parentElement.parentElement
          .nextElementSibling.children[0].children[0].id == 'total-qty'
      ) {
        event.target.parentElement.parentElement.parentElement.nextElementSibling.nextElementSibling.children[0].children[0].nextElementSibling.focus()
      } else {
        event.target.parentElement.parentElement.parentElement.nextElementSibling.children[0].children[0].children[0].focus()
      }
    },
    nextFocusDiscount(event, index) {
      this.addNewRow()
      setTimeout(() => {
        event.target.parentElement.parentElement.parentElement.children[
          index + 1
        ].children[0].nextElementSibling.children[0].children[0].children[0].focus()
      }, 0)
    },
    getDetailPurchase(index) {
      let code = ''
      if (this.items_temp[index].dropdownItem != undefined) {
        if (this.items_temp[index].dropdownItem instanceof Object) {
          code = this.items_temp[index].dropdownItem.code
        } else {
          code = this.items_temp[index].dropdownItem
        }
      }

      this.$http
        .get(
          `${process.env.VUE_APP_API_URL}/warehouse-items?code=${code}&name=&show_empty_stock=true&page=&limit=5`
        )
        .then(response => {
          this.loading = false
          if (response.status === 200) {
            this.dropdownItems = response.data.data.items
          } else {
            console.error('gagal get')
          }
        })
    },
    getOutlets() {
      this.$http
        .get(`${process.env.VUE_APP_API_URL}/outlets?`)
        .then(response => {
          this.loading = false
          if (response.status === 200) {
            this.outlets = response.data.data.outlets
          } else {
            console.error('gagal get')
          }
        })
    },
    chooseDropdownChanges(index, an_item) {
      this.isError.items[index].kode_barang = false
      if (index > -1) {
        this.items_temp[index].dropdownItem = an_item.dropdownItem
        this.items_temp[index].item_name = an_item.dropdownItem
        this.items_temp[index].cap_price = an_item.dropdownItem.cap_price
        this.items_temp[index].cap_priceRP =
          'Rp ' + this.formatPrice(this.items_temp[index].cap_price)
        this.items_temp[index].item_id = an_item.dropdownItem.id
      }
    },
    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    },
    addNewRow() {
      let tmp = []
      for (var i = 0; i < this.outlets.length; i++) {
        tmp.push({
          id: 0,
          outlet_id: this.outlets[i].id
        })
      }
      this.items_temp.push({
        item_name: {
          item_name: null
        },
        item_id: '',
        generateCode: true,
        code: '',
        name: '',
        warehouse_outbounds: tmp,
        newItem: true,
        dropdownItem: null,
        priceInRp: null
      })
      this.isError.items.push({
        kode_barang: false,
        price: false
      })
      this.error_msg.items.push({
        kode_barang: '',
        price: ''
      })
    },
    deleteRow(index, an_item) {
      var idx = this.items_temp.indexOf(an_item)
      if (idx > -1) {
        this.items_temp.splice(idx, 1)
        this.isError.items.splice(idx, 1)
        this.error_msg.items.splice(idx, 1)
      }
    },
    submit() {
      this.inputData.items = []
      this.inputData.type = ''
      this.items_checked = true

      for (var i = 0; i < this.items_temp.length; i++) {
        var item = this.items_temp[i]
        if (item.dropdownItem == null) {
          this.isError.items[i].kode_barang = true
          this.error_msg.items[i].kode_barang = 'mohon pilih kode barang'
          this.items_checked = false
        }

        if (
          Number(item.priceInRp) != 0 &&
          Number(item.priceInRp) <= Number(item.cap_price)
        ) {
          this.isError.items[i].price = true
          this.error_msg.items[i].price =
            'harga jual harus lebih besar dari harga modal'
          this.items_checked = false
        } else {
          this.isError.items[i].price = false
        }
        this.inputData.items.push({
          item_id: '',
          price: '',
          warehouse_outbounds: []
        })
        this.inputData.items[i].warehouse_outbounds = []
        for (var a = 0; a < item.warehouse_outbounds.length; a++) {
          this.inputData.items[i].warehouse_outbounds.push({
            outlet_id: item.warehouse_outbounds[a].outlet_id,
            price: item.warehouse_outbounds[a].price
          })
        }

        this.inputData.items[i].item_id = item.item_id
        this.inputData.items[i].price = item.priceInRp
      }
      this.loading_simpan = true
      if (this.items_checked == true) {
        this.$http
          .post(
            `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/price-mutations`,
            this.inputData
          )
          .then(response => {
            if (response.status === 200) {
              this.$toast.add({
                severity: 'success',
                summary: 'Berhasil Tambah Mutasi',
                detail: 'Distribusi keluar berhasil dibuat',
                life: 3000
              })
              this.loading_simpan = false
              this.clearData()
            } else {
              this.$toast.add({
                severity: 'error',
                summary: 'Gagal Tambah Mutasi',
                detail: 'Distribusi keluar gagal dibuat',
                life: 3000
              })
              this.loading_simpan = false
            }
          })
      }
    },
    clearData() {
      this.items_temp = []
      this.isError.items.push({
        kode_barang: false,
        price: false
      })
      this.error_msg.items.push({
        kode_barang: '',
        price: ''
      })
      this.dropdownSupplier = null
      this.inputData.items = []
      this.inputData.type = ''
    }
  }
}
</script>

<style scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.priceCol {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 150px;
}

.item {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 180px;
}

.harga {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 120px;
}

.qty-awal {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 60px;
}

.qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 50px;
}

.total-qty {
  display: flex;
  align-items: center;
  justify-content: space-around;
  width: 60px;
}

table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;
  border: 5px solid #ddd;
  margin-right: 15px;
  margin-left: 15px;
}

.scrollable {
  display: inline-block;
}

.priceCol div {
  margin-right: 15px;
}
</style>
